import apiinfo from "../../../../utils/base-uri.json";
import { useForm } from "react-hook-form";
import OutlinedInput from "@mui/material/OutlinedInput";
import { FormControl, Tooltip, Select, MenuItem, Checkbox, ListItemText, Button, TextField } from '@mui/material'
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "../../../../utils/fvAxios";
import useFetch from "../../../../utils/useFetch";
import { getGlobalClientId, getOrgType, getToken } from "../../../../utils/Token";
import BaseURL from "../../../../utils/base-uri.json";
import React, { useState, useEffect, useRef } from 'react';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";


export default function ReportContractorEvalution({ close, name }) {
  const [selectValue1, setSelectValue1] = useState('');
  const [client, setClient] = React.useState([]);
  const [error, setError] = useState(null);
  const [data, setData] = React.useState([]);
  const [sitedata, setSiteData] = React.useState([]);
  const [token, setToken] = useState(getToken())

  useEffect(() => {
    axios
      .get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false&ClientIds=" +
        getGlobalClientId())
      .then((res) => {
        if (res?.data?.responseCode === 100) {
          setClient(res?.data?.data);
          if (getOrgType() == "Client") {
            setSelectValue1(res?.data?.data[0]?.value)
          }

        } else {
          setError(res.data.responseMessage);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const { register } = useForm();

  const changeClients = (e) => {
    setSelectValue1(e);
  };
  const menuListRef = useRef(null);
  const scrollToTopOfOtions = () => {
    setTimeout(() => {
      if (menuListRef.current) {
        const children = menuListRef.current.children;
        if (children.length >= 2) {
          const secondLastOption = children[children.length - 2];
          if (secondLastOption) {
            secondLastOption.scrollTop = 0;
          }
        }
      }
    }, 5);
  };
  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };
  const { data: res } = useFetch(
    "SystemUser/GetClientUsersData?ClientId=" + selectValue1

  );
  useEffect(() => {
    if (res?.data) {
      setData(res?.data)

    }
  }, [res]);
  const { data: resp } = useFetch(
    "Client/GetBuSitesByClientId?clientId=" + selectValue1

  );
  useEffect(() => {
    if (resp?.data) {
      setSiteData(resp?.data)

    }
  }, [resp]);

  const [selectedsite, setSelectedsite] = useState([]);
  const [score, setScore] = useState('');
  const [reviewtype, setReviewtype] = useState('');
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [fromDateValue, setFromDateValue] = useState(null);
  const [toDateValue, setToDateValue] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const handleDocTypeChange = (event) => {
    setSelectedDocs(event.target.value);
  };
  const handleDocTypeChange1 = (event) => {
    setSelectedsite(event.target.value);
  };

  const handleFromDateChange = (date) => {
    setFromDateValue(date);
    if (date && toDateValue && date > toDateValue) {
      setShowAlert(true);
    } else {
      setShowAlert(false);
    }
  };

  const handleToDateChange = (date) => {
    setToDateValue(date);
    if (fromDateValue && date && fromDateValue > date) {
      setShowAlert(true);
    } else {
      setShowAlert(false);
    }
  };
  const handleDateKeyDown = (e) => {
    e.preventDefault(); // Prevent manual date input
  };

  return (
    <>
      <DialogTitle id="alert-dialog-title">{name}</DialogTitle>
      <DialogContent>
        <form
          action={
            BaseURL?.baseReportUrl + "ScoreCardReviews.aspx"
          }
          method="post"
          target="_blank"
        >
          <div style={{ marginLeft: "25px" }}>
            {showAlert && (
              <div className="alert mx-2" style={{ color: "red", padding: "2px" }}>
                Evaluated From date should be less than Evaluated To date
              </div>
            )}
            <FormControl sx={{ m: 1, width: 320 }}>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: "0px",
                  marginBottom: "5px",
                }}
              >
                Client
              </span>
              <Select

                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  fontFamily: "Arial, FontAwesome",
                }}

                size="small"
                name="clientOrgId"
                onChange={(e) => changeClients(e.target.value)}
                input={
                  <OutlinedInput label="Select Client" value={selectValue1} />
                }
                MenuProps={MenuProps}
              >
                {client?.map((item, index) => (
                  <MenuItem key={index} title={item.text} value={item.value}>
                    {item.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ marginLeft: 1, width: 320 }}>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",

                  marginBottom: "5px",
                }}
              >
                Score
              </span>
              <Select
                labelId="days-label"
                id="days-select"
                name="score"
                value={score}
                inputProps={{ "aria-label": "Select Days" }}
                onChange={(e) => setScore(e.target.value)}
                displayEmpty
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  fontFamily: "Arial, FontAwesome",
                }}
                size="small"
              >
                <MenuItem value="">Any</MenuItem>
                <MenuItem value="1">0-1</MenuItem>
                <MenuItem value="2">1-2</MenuItem>
                <MenuItem value="3">2-3</MenuItem>
              </Select>
            </FormControl>
            <FormControl sx={{ marginLeft: 1, width: 320 }}>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: 4,
                  marginBottom: "5px",
                }}
              >
                Review Type
              </span>
              <Select
                labelId="days-label"
                id="days-select"
                name="reviewType"
                displayEmpty
                value={reviewtype}
                inputProps={{ 'aria-label': 'Select Days' }}
                onChange={(e) => setReviewtype(e.target.value)}
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  fontFamily: "Arial, FontAwesome",
                }}
                size="small"
              >
                <MenuItem value="">Any</MenuItem>
                <MenuItem value="0">Annual</MenuItem>
                <MenuItem value="1">Project</MenuItem>
                <MenuItem value="2">BI-Annual</MenuItem>
              </Select>
            </FormControl>
            <FormControl sx={{ marginLeft: 1, width: 320 }}>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: 4,
                  marginBottom: "5px",
                }}
              >
                Client User
              </span>
              {/* <Select
                labelId="docs-label"
                id="docs-select"
                multiple
                size='small' sx={{ width: "320px", overflow: "hidden" }}
                name="userIds"
                value={selectedDocs || [data[0]?.userId]}
                onChange={handleDocTypeChange}
                MenuProps={MenuProps}
                renderValue={(selected) =>
                  selected
                    .map((value) => data.find((doc) => doc.userId === value)?.name)
                    .filter((value) => value !== undefined)
                    .join(", ")
                }
                inputProps={{ 'aria-label': 'Select Documents' }}
              >

                {data?.map((doc) => (
                  <MenuItem key={doc.userId} value={doc.userId}>
                    <Checkbox checked={selectedDocs.indexOf(doc?.userId) > -1} />
                    <ListItemText primary={ doc?.name} />
                  </MenuItem>
                ))}
              </Select> */}
              <Select
                labelId="docs-label"
                id="docs-select"
                multiple
                size='small' sx={{ width: "320px", overflow: "hidden" }}
                name="userIds"
                value={selectedDocs || [data[0]?.userId]}
                onChange={handleDocTypeChange}
                MenuProps={{
                  ref: menuListRef,
                  PaperProps: MenuProps.PaperProps,
                }}
                renderValue={(selected) =>
                  selected
                    .map((value) => data.find((doc) => doc.userId === value)?.name)
                    .filter((value) => value !== undefined)
                    .join(", ")
                }
                inputProps={{ 'aria-label': 'Select Documents' }}
              >
                <MenuItem key="Select All">
                  <Checkbox
                    id="select-all-checkbox"
                    indeterminate={
                      selectedDocs?.length > 0 && selectedDocs?.length < data?.length
                    }
                    checked={selectedDocs?.length === data?.length}
                    onChange={(event) => {
                      if (event?.target?.checked) {
                        setSelectedDocs(data?.map((doc) => doc?.userId));
                        scrollToTopOfOtions();
                      } else {
                        setSelectedDocs([]);
                      }
                    }}
                  />
                  <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                    Select All
                  </label>

                </MenuItem>
                {data?.map((doc) => (
                  <MenuItem key={doc?.userId} value={doc?.userId} title={doc?.name} sx={{ overflowX: "hidden", textOverflow: "ellipsis" }} >
                    <Checkbox checked={selectedDocs?.indexOf(doc?.userId) > -1} />
                    <ListItemText primary={doc?.name} sx={{ overflowX: "hidden", textOverflow: "ellipsis" }} />
                  </MenuItem>

                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ marginLeft: 1, width: 320 }}>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: 4,
                  marginBottom: "5px",
                }}
              >
                Sites
              </span>

              <Select
                labelId="docs-label"
                id="docs-select"
                multiple
                size='small' sx={{ width: "320px", overflow: "hidden" }}
                name="ClientSite"
                value={selectedsite}
                onChange={handleDocTypeChange1}
                MenuProps={{
                  ref: menuListRef,
                  PaperProps: MenuProps.PaperProps,
                }}
                renderValue={(selected) =>
                  selected
                    .map((value) => sitedata.find((doc) => doc.key === value)?.value)
                    .filter((value) => value !== undefined)
                    .join(", ")
                }
                inputProps={{ 'aria-label': 'Select Documents' }}
              >
                <MenuItem key="Select All">
                  <Checkbox
                    id="select-all-checkbox"
                    indeterminate={
                      selectedsite?.length > 0 && selectedsite?.length < sitedata?.length
                    }
                    checked={selectedsite?.length === sitedata?.length}
                    onChange={(event) => {
                      if (event?.target?.checked) {
                        setSelectedsite(sitedata?.map((doc) => doc?.key));
                        scrollToTopOfOtions();
                      } else {
                        setSelectedsite([]);
                      }
                    }}
                  />
                  <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                    Select All
                  </label>

                </MenuItem>
                {sitedata?.map((doc) => (
                  <MenuItem key={doc?.key} value={doc?.key} title={doc?.value} sx={{ overflowX: "hidden", textOverflow: "ellipsis" }} >
                    <Checkbox checked={selectedsite?.indexOf(doc?.key) > -1} />
                    <ListItemText primary={doc?.value} sx={{ overflowX: "hidden", textOverflow: "ellipsis" }} />
                  </MenuItem>
                ))}

              </Select>
            </FormControl>
            <FormControl sx={{ marginLeft: 1, width: 320 }}>
              <span style={{ color: "#3E4A62", fontSize: "14px", fontWeight: "500", marginTop: "5px", marginBottom: "5px" }}>Evaluated From</span>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={["year", "month", "day"]}
                  value={fromDateValue}
                  onChange={handleFromDateChange}
                  name="fromDate"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px",
                      }}
                      size="small"
                      name="fromDate"
                      onKeyDown={handleDateKeyDown}
                    />
                  )}
                />
              </LocalizationProvider>
            </FormControl>
            <FormControl sx={{ marginLeft: 1, width: 320 }}>
              <span style={{ color: "#3E4A62", fontSize: "14px", fontWeight: "500", marginTop: "5px", marginBottom: "5px" }}>Evaluated To</span>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={["year", "month", "day"]}
                  value={toDateValue}
                  name="toDate"
                  onChange={handleToDateChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px",
                      }}
                      name="toDate"
                      size="small"
                      onKeyDown={handleDateKeyDown}
                    />
                  )}
                />
              </LocalizationProvider>
            </FormControl>
          </div>
          <DialogActions>
            <div className="login-help__buttonContainer">
              <Button
                variant="contained"
                className="login-help-button-cancel"
                onClick={close}
              >
                {" "}
                Cancel
              </Button>
              {selectValue1 == "" ||
                selectedDocs == "" ||
                showAlert ? (
                <Tooltip title="All the fields are mandatory" followCursor>
                  <span>
                    <Button
                      variant="contained"
                      className="login-button-request"
                      onClick={close}
                      disabled={
                        showAlert ||
                        selectValue1 == "" ||
                        selectedDocs == "" 
                      }
                    >
                      Create Report
                    </Button>
                  </span>
                </Tooltip>
              ) : (
                <Button
                  variant="contained"
                  type="submit"
                  className="login-button-request"
                  onClick={close}
                >
                  Create Report
                </Button>
              )}
            </div>
          </DialogActions>
          <input type="hidden" name="token" value={token} />
        </form>

      </DialogContent >

    </>
  );
}


